import axios from '../../axios';
import { toast } from 'react-toastify';
import { ADD_SERIES, DELETE_SERIES, GET_SERIES, UPDATE_SERIES, GET_ONE_SERIES, MULTI_DELETE_SERIES } from '../types';

export const getSeries = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/series/all', {
         params,
      });

      if (res.data.code === 1) {
         dispatch({
            type: GET_SERIES,
            payload: {
               data: res.data.data, // your actual data array
               pagination: res.data.pagination, // your pagination object
            },
         });
      }
   } catch (err) {
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
      // console.error("Failed to get Series. Please try again. :", err);
   }
};

export const addSeries = (formData) => async (dispatch) => {
   try {
      const res = await axios.post('/series/add', formData);
      if (res.data.code === 1) {
         dispatch({ type: ADD_SERIES, payload: res.data.data });
         setTimeout(() => {
            toast.success('Series added successfully!');
         }, 1000);
         return;
      }
      if (res.data.code === 0) {
         setTimeout(() => {
            toast.error(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.status === 400) {
         toast.warn(err.response.data.message);
         return;
      }
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};

export const updateSeries = (formData) => async (dispatch) => {
   try {
      const res = await axios.post(`/series/update`, formData);

      if (res.data.code === 1) {
         dispatch({ type: UPDATE_SERIES, payload: res.data.data });

         setTimeout(() => {
            toast.success('Series updated successfully!');
         }, 1000);
      }
   } catch (err) {
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
      // toast.error('Failed to update Series. Please try again.');
   }
};

// Delete Series
export const deleteSeries = (id, companyId) => async (dispatch) => {
   try {
      if (!id) {
         toast.error('Please select any record');
         return false;
      }
      const res = await axios.post(`/series/delete/${id}/${companyId}`);
      if (res.data.code === 1) {
         dispatch({ type: DELETE_SERIES, payload: { id } });
         toast.success('Series deleted successfully!');
      }
   } catch (err) {
      if (err.response.status === 400) {
         toast.error(err.response.data.message);
         return;
      }
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
      // toast.error('Failed to delete Series. Please try again.');
   }
};

export const getSingleSeries = (id) => async (dispatch) => {
   try {
      const res = await axios.get(`/series/${id}`);
      if (res.data.code === 1) {
         dispatch({ type: GET_ONE_SERIES, payload: res.data.data });
      }
   } catch (err) {
      console.error('Failed to get item by finish item. Please try again.');
      if (err.response.data.message) {
         toast.error(err.response.data.message);
      }
   }
};

export const multiDeleteSeries = (formData) => async (dispatch) => {
   try {
      const res = await axios.post(`/series/delete/multi`, formData);

      if (res.data.code === 1) {
         dispatch({ type: MULTI_DELETE_SERIES, payload: res.data.data });

         setTimeout(() => {
            toast.success('Series deleted successfully!');
         }, 1000);
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.status === 400) {
         toast.error(err.response.data.message);
         return;
      }
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
      // toast.error('Failed to update customer. Please try again.');
   }
};
